import React from 'react';
import { ArrowRight } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-20 px-6 relative overflow-hidden bg-[#161616]" data-id="element-109">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-brand-rose/10 pointer-events-none" data-id="element-110" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-rose/20 rounded-full blur-[150px] pointer-events-none" data-id="element-111" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-112">
        <FadeIn data-id="element-113">
          <h2 className="font-serif text-5xl md:text-7xl font-bold mb-6" data-id="element-114">
            Decisión <span className="text-brand-rose italic" data-id="element-115">Final</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-116">
          <div className="grid md:grid-cols-2 gap-6 mb-8 text-left" data-id="element-117">
            <div className="p-6 rounded-3xl bg-brand-gray/50 border border-white/5 opacity-70" data-id="element-118">
              <h3 className="text-xl font-semibold mb-3 text-brand-lightGray" data-id="element-119">
                Puedes seguir:
              </h3>
              <ul className="space-y-2 text-brand-lightGray/80" data-id="element-120">
                <li data-id="element-121">• Dudando de cada mensaje</li>
                <li data-id="element-122">• Pensando demasiado</li>
                <li data-id="element-123">• Sintiéndote ignorada</li>
              </ul>
            </div>

            <div className="p-6 rounded-3xl bg-gradient-to-br from-brand-rose/20 to-transparent border border-brand-rose/30" data-id="element-124">
              <h3 className="text-xl font-semibold mb-3 text-brand-cream" data-id="element-125">
                O puedes:
              </h3>
              <ul className="space-y-2 text-brand-cream" data-id="element-126">
                <li data-id="element-127">• Aprender el sistema</li>
                <li data-id="element-128">• Tomar el control emocional</li>
                <li data-id="element-129">• Volverte magnética</li>
              </ul>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-130">
          <p className="text-2xl md:text-3xl font-serif text-brand-cream mb-8 italic" data-id="element-131">
            "No quieres esperar respuesta. <br className="hidden md:block" data-id="element-132" />
            <span className="text-brand-rose font-bold not-italic" data-id="element-133">
              Quieres provocarla. 🔥
            </span>
            "
          </p>

          <a href="#pricing" className="group relative inline-flex items-center justify-center gap-3 px-10 py-5 bg-brand-rose text-white text-lg font-bold rounded-full overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_40px_rgba(225,29,72,0.4)] active:scale-95" data-id="element-134">
            <span className="relative z-10 flex items-center gap-2" data-id="element-135">
              Sí, Quiero Empezar Hoy{' '}
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-136" />
            </span>
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-137" />
          </a>
          <p className="mt-4 text-brand-lightGray text-sm" data-id="element-138">
            Acceso inmediato y seguro.
          </p>
        </FadeIn>
      </div>
    </section>;
}